/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttributeInfoDTO
 */
export interface AttributeInfoDTO {
    /**
     * 
     * @type {boolean}
     * @memberof AttributeInfoDTO
     */
    active?: boolean;
}

/**
 * Check if a given object implements the AttributeInfoDTO interface.
 */
export function instanceOfAttributeInfoDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AttributeInfoDTOFromJSON(json: any): AttributeInfoDTO {
    return AttributeInfoDTOFromJSONTyped(json, false);
}

export function AttributeInfoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttributeInfoDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': !exists(json, 'active') ? undefined : json['active'],
    };
}

export function AttributeInfoDTOToJSON(value?: AttributeInfoDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
    };
}

